<template>
  <div class="string-rule">
    <b-input type="text" v-model="vm.localModel" data-cy="search-txt" />
  </div>
</template>
<script setup lang="ts">
import { reactive, watch } from "vue";

//#region General
const props = defineProps<{ value: string }>();
const emits = defineEmits(["input"]);
//#endregion

//#region ViewModel
type ViewModel = { localModel: string };
const vm = reactive<ViewModel>({ localModel: props.value });
//#endregion

//#region Update vModel
watch(
  () => vm.localModel,
  (nv) => {
    emits("input", nv);
  }
);
//#endregion
</script>
